import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";
import SubText from "components/shared/SubText";
import MusicSkeleton from "components/skeleton/MusicSkeleton";
import { RouteName } from "constant/routeNames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PlaylistService from "services/music/PlaylistService";

const PlaylistCoursel = lazy(
  () => import("pages/musicPage/playlist/PlaylistCoursel"),
);

function WelcomePageDiscoverPlaylists({ welcomePage }: any) {
  const [isLoadingPlaylist, setIsLodingPlaylist] = useState<any>(false);
  const [publicPlaylists, setPublicPlaylists] = useState<any>([]);
  const [isLoading, setIsLoding] = useState<any>(false);

  useEffect(() => {
    setIsLoding(true);
    setIsLodingPlaylist(true);
    PlaylistService.getPublicPlaylists()
      .then((res: any) => {
        setIsLodingPlaylist(false);
        setIsLoding(false);
        // console.log("first", res.data.data);
        setPublicPlaylists(res.data.data);
      })
      .catch((e) => {
        setIsLoding(false);
        setIsLodingPlaylist(false);
        // setIsLoding(false);
        // console.log(e);
      });
  }, []);
  return (
    <div>
      {!isLoading && (
        <>
          <ErrorBoundary>
            <Suspense fallback={<MusicSkeleton />}>
              {publicPlaylists.length != "0" && (
                <>
                  <div className="mb-20">
                    <div className="mt-5 flex w-[95%] flex-row items-center justify-between">
                      <SectionHeading
                        text="Discover Playlists"
                        className="font-bold"
                      />
                      <Link
                        to={RouteName.SeeAllDiscoverPlaylistsRoute}
                        className="group shrink-0"
                      >
                        <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                          See all
                          <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                            →
                          </span>
                        </p>
                      </Link>
                    </div>
                    <PlaylistCoursel
                      playlists={publicPlaylists}
                      isLoadingPlaylist={isLoadingPlaylist}
                      welcomePage={welcomePage}
                      isLoading={isLoading}
                    />
                  </div>
                </>
              )}
            </Suspense>
          </ErrorBoundary>
        </>
      )}
      {isLoading && <MusicSkeleton />}
    </div>
  );
}

export default WelcomePageDiscoverPlaylists;